<template>
  <div>
    <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
      <div class="col-12 col-md-4">
        <label class="form-label">{{ $t('users.inputs.entity') }}:</label>
        <multiselect
          v-model="filters.entity"
          :options="entities"
          track-by="id"
          label="name"
          :custom-label="formatedEntityLabel"
          select-label=""
          selected-label=""
          deselect-label="×"
          placeholder="---"
          :searchable="true"
          :allow-empty="true"
          :multiple="false"
          :limit="1"
          :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')"
          :close-on-select="true"
        >
          <span slot="noResult">{{this.$t('patients.noResults')}}</span>
          <template slot="clear" slot-scope="props">
            <div class="multiselect__clear" v-if="filters.entity !== null" @mousedown.prevent.stop="filters.entity = null"></div>
          </template>
        </multiselect>
      </div>
    </div>
    <v-server-table
      id="placingsTable"
      ref="placingsTable"
      :name="'placingsTable'"
      :columns="columns"
      :options="tableOptions"
      @row-click="selectPlacing"
      @filter="filterListener">

      <span slot="coordinates" class="no-break" slot-scope="props">
          <span v-if="props.row.lat && props.row.lng">
            {{ props.row.lat | coordinate }}, {{ props.row.lng | coordinate }}
          </span>
        </span>
      <!-- <span slot="h__name">{{'users.inputs.name'| translate}}</span>
      <span slot="h__entity">{{'users.inputs.entity'| translate}}</span> -->
    </v-server-table>
  </div>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
import Multiselect from 'vue-multiselect'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
export default {
  mixins: [
    TableQueryMixin,
    MultiselectLabelFormatter,
  ],
  components: {
    Multiselect
  },
  props: {
    entities: {
      type: Array,
      required: true
    },
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      filters: {
        entity: null,
        querySearch: '',
      },
      selectedPlacing: null,
      isloading: false,
      newPlacing: false,
      editingName: '',
      editingLat: '',
      editingLng: '',
      editingEntity: 0,
      placings: [],
      showResetIcon: false,
      columns: ['name', 'coordinates'],
      queryUrl: `${this.$store.state.evollead_server}/placings`,
      tableOptions: {
        storage: 'local',
        filterable: ['name'],
        sortable: ['name'],
        customFilters: ['entity'],
        headings: {
          name: this.$t('users.inputs.name'),
          coordinates: this.$t('placings.coordinates')
        },
        saveState: true,
      },
    }
  },
  filters: {
    coordinate: function (value) {
      return value.toFixed(6)
    }
  },
  methods: {
    reload: function () {
      this.$refs.placingsTable.refresh()
    },
    filterListener (query) {
      this.showResetIcon = query.length > 0
    },
    resetFilter () {
      this.showResetIcon = false
      this.$refs.placingsTable.setFilter('')
    },
    selectPlacing: function (placing) {
      this.$emit('selectedPlacing', placing)
    },
    closeEditPlacing: function () {
      this.editingName = ''
      this.editingLat = ''
      this.editingLng = ''
      this.editingEntity = 0
      this.showEditPlacing = false
    },
    getTableReference: function () {
      return this.$refs.placingsTable
    }
  },
  computed: {
    activeFilters: function () {
      let count = 0
      if (this.filters.entity !== null && this.filters.entity !== '') count++
      return count
    },
  },
  watch: {
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      },
      immediate: true
    },
    customQueries: {
      handler: function (value) {
        if (value.entity !== '' && value.entity !== null) {
          this.filters.entity = this.entities.find(entity => entity.id === value.entity)
        }
      }
    },
    'filters.entity': function () {
      if (this.filters.entity) {
        this.emitTableFilter('vue-tables.placingsTable.filter::entity', this.filters.entity.id)
      } else {
        this.emitTableFilter('vue-tables.placingsTable.filter::entity', null)
      }
    },
    activeFilters: function (nrFilters) {
      this.$emit('filters-updated', nrFilters)
    },
    'filters.querySearch': function (value) {
      this.$refs.placingsTable.setFilter(value)
    },
  }
}
</script>

<style scoped>

table {
  cursor: pointer;
}
</style>
